//types
import { RootState } from "../../../../types/store";

//import redux
import { connect } from "react-redux";

// actions
import { getOriginsRequest } from "../../../../redux/actions/origins.actions";
import { getLeadersRequest } from "../../../../redux/actions/leaders.actions";
import { getSupervisorsRequest } from "../../../../redux/actions/supervisors.actions";
import { getSellersRequest } from "../../../../redux/actions/sellers.actions";
import { getStatesRequest } from "../../../../redux/actions/states.actions";
import { getChannelsRequest } from "../../../../redux/actions/channels.actions";
import { getClientsRequest } from "../../../../redux/actions/clients.actions";
import { getOperationTypesRequest } from "../../../../redux/actions/operationTypes.actions";

import BusinessFiltersComponent from "./BusinessFilters.component";
const mapStateToProps = function (state: RootState) {
  return {
    origins: state.origins.originsList,
    fetchingOriginsList: Boolean(state.origins.fetchingOriginsList > 0),
    leaders: state.leaders.leadersList,
    fetchingLeadersList: Boolean(state.leaders.fetchingLeadersList > 0),
    supervisors: state.supervisors.supervisorsList,
    fetchingSupervisorsList: Boolean(
      state.supervisors.fetchingSupervisorsList > 0
    ),
    sellers: state.sellers.sellersList,
    fetchingSellersList: Boolean(state.sellers.fetchingSellersList > 0),
    states: state.states.statesList,
    fetchingStatesList: Boolean(state.states.fetchingStatesList > 0),
    channels: state.channels.channelsList,
    fetchingChannelsList: Boolean(state.channels.fetchingChannelsList > 0),
    clients: state.clients.clientsList,
    fetchingClientsList: Boolean(state.clients.fetchingClientsList > 0),
    operationTypes: state.operationTypes.operationTypesList,
    fetchingOperationTypesList: Boolean(state.operationTypes.fetchingOperationTypesList > 0),
  };
};

const mapDispatchToProps = function (dispatch: any) {
  return {
    getOriginsRequest: (data: any, params: any) =>
      dispatch(getOriginsRequest(data, params)),
    getLeadersRequest: (data: any, params: any) =>
      dispatch(getLeadersRequest(data, params)),
    getSupervisorsRequest: (data: any, params: any) =>
      dispatch(getSupervisorsRequest(data, params)),
    getSellersRequest: (data: any, params: any) =>
      dispatch(getSellersRequest(data, params)),
    getStatesRequest: (data: any, params: any) =>
      dispatch(getStatesRequest(data, params)),
    getChannelsRequest: (data: any, params: any) =>
      dispatch(getChannelsRequest(data, params)),
    getClientsRequest: (data: any, params: any) =>
      dispatch(getClientsRequest(data, params)),
    getOperationTypesRequest: (data: any, params: any) =>
        dispatch(getOperationTypesRequest(data, params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessFiltersComponent);
